import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import {
  ExternalLink
} from '../';

import css from './SectionAsSeenOn.css';

const SectionAsSeenOn = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);
  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionAsSeenOn.title" />
      </div>
      <div className={css.sites}>

        <ExternalLink className={css.site} href="https://www.racv.com.au/royalauto/living/community/sharing-economy.html" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/racv.png" alt="site" />
        </ExternalLink>
        <ExternalLink className={css.site} href="https://2ser.com/episodes/think-business-futures-1130am-7th-oct-2018/" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/think_business_futures.png" alt="site" />
        </ExternalLink>
        <ExternalLink className={css.site} href="https://www.theinnerwestmums.com.au/getting-to-know-vanouhi-nazarian-of-kindershare" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/inner_west_mums.png" alt="site" />
        </ExternalLink>
        <ExternalLink className={css.site} href="https://www.startupdaily.net/2018/01/sydney-startup-kindershare-peer-peer-network-facilitating-rental-baby-equipment/" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/startup_daily.png" alt="site" />
        </ExternalLink>
        <ExternalLink className={css.site} href="https://insidesmallbusiness.com.au/planning-management/qa-share-and-share-alike" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/inside_small_business.png" alt="site" />
        </ExternalLink>


        <ExternalLink className={css.site} href="https://kindershare.com/blog/2019/03/06/kindershare-featured-on-a-current-affair/" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/current_affair.png" alt="site" />
        </ExternalLink>
        <ExternalLink className={css.site} href="https://www.ellaslist.com.au/family-holidays/how-does-the-airline-ban-on-sleeping-devices-fly-with-you" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/ellaslist.png" alt="site" />
        </ExternalLink>
        <ExternalLink className={css.site} href="https://www.healthynumbers.com.au/podcast/vanouhi-nazarian-founder-kindershare/" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/healthy_numbers.png" alt="site" />
        </ExternalLink>
        <ExternalLink className={css.site} href="https://thesharingmap.com.au/" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/sharing_map.png" alt="site" />
        </ExternalLink>
        <span className={css.site} >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/mumspages.png" alt="site" />
        </span>


        <span className={css.site} >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/canstar.png" alt="site" />
        </span>
        <span className={css.site} >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/holidays_with_kids.png" alt="site" />
        </span>
        <ExternalLink className={css.site} href="https://www.kidspot.com.au/baby/real-life/reader-stories/three-mums-who-started-their-own-business-on-maternity-leave/news-story/e80335eb217c4ad2f1fb7ea2441d27c1" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/kidspot.png" alt="site" />
        </ExternalLink>
        <span className={css.site} >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/share.png" alt="site" />
        </span>
        <span className={css.site} >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/busy_mum_podcast.png" alt="site" />
        </span>


        <span className={css.site}>
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/ibisworld.png" alt="site" />
        </span>
        <ExternalLink className={css.site} href="https://www.smh.com.au/business/workplace/mothers-of-invention-20180927-p506ic.html" >
          <img src="https://kindershare-public-files.s3-ap-southeast-2.amazonaws.com/site-logos/smh.png" alt="site" />
        </ExternalLink>

      </div>
    </div>
  );
};

SectionAsSeenOn.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionAsSeenOn.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionAsSeenOn;
